export default function EcoFriendly() {
  return (
    <section className="py-24 bg-gray-50 relative overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/98e51a0c70a1b7753328e9c1ee63e6c5.jpg" 
          alt="Eco friendly" 
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-50/90 via-gray-50/80 to-gray-50/90"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div className="flex items-center justify-center w-20 h-20 bg-green-500 rounded-full mx-auto mb-8">
          <i className="ri-leaf-line text-4xl text-white"></i>
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">A Greener Way To Move</h2>
        <p className="text-xl text-gray-700 mb-6 leading-relaxed">
          Reusable totes eliminate thousands of cardboard boxes from landfills every year.
        </p>
        <p className="text-lg text-gray-600 leading-relaxed">
          Moving with BoxFreeMove is better for your home and better for the planet.
        </p>
      </div>
    </section>
  );
}
